import React, { useEffect } from "react";
import { CountdownCircleTimer } from "react-countdown-circle-timer";



const Countdown = ({
  duration = 20,
  initial = 0,
  isOvertime = false,
  onComplete,
  counterMaxTime,
}) => {
  const visualDuration = isOvertime ? counterMaxTime : duration;

  return (
    <div style={{ width: 220, margin: "auto" }}>
      <CountdownCircleTimer
        isPlaying
        duration={visualDuration}
        colors={isOvertime ? "#cb6666" : "#93C2E4"} // if its overtime then it will display red ish color
        initialRemainingTime={initial}
        trailColor="#eeeeee"
        strokeWidth={40}
        size={220}
        strokeLinecap="butt"
        isSmoothColorTransition
        onComplete={onComplete}
        isGrowing={isOvertime ? true : false}// if its overtime then the counter will go negative
      >
        {({ remainingTime }) => {
          const time = isOvertime
            ? visualDuration - remainingTime
            : remainingTime;

          const minutes = Math.floor(Math.abs(time) / 60)
            .toString()
            .padStart(2, "0");
          const seconds = (Math.abs(time) % 60).toString().padStart(2, "0");

          return (
            <div
              style={{
                fontSize: "24px",
                fontWeight: "bold",
                // color: isOvertime ? "#e22028" : "inherit"
              }}
            >
              {isOvertime && "-"}
              {minutes}:{seconds}
            </div>
          );
        }}
      </CountdownCircleTimer>
    </div>
  );
};

export default Countdown;
